import { inject } from '@angular/core';
import type {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { Location } from '@freelancer/location';
import { LOGIN_AUTH_SERVICE } from '@freelancer/login';
import { map } from 'rxjs/operators';

export const LoggedOutOnlyPageGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): ReturnType<CanActivateFn> => {
  const auth = inject(LOGIN_AUTH_SERVICE);
  const location = inject(Location);

  return auth.isLoggedIn().pipe(
    map(loggedIn => {
      const { next } = route.queryParams;
      if (loggedIn) {
        return location.createUrlTree([next || '/']);
      }
      return true;
    }),
  );
};
